import React, { Fragment, useState } from "react";

import {Card, 
    CardContent,
    Chip,
    Typography,
} from '@mui/material';

import Inbounds from "./Inbounds";
import Outbounds from "./Outbounds";

const Queues = ({queues, inboundTime, outboundTime}) => {
    const [type, setType] = useState("Inbounds");
    return(
        <Fragment>
            <Card variant="outlined">
                <CardContent>
                <Typography component="h2" variant="subtitle2" gutterBottom 
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between'
                        }}
                    >
                        <div className="pc-dash-queues-head">
                            <span>
                                <Chip 
                                    size="small" 
                                    color="primary" 
                                    variant={type==='Inbounds' ? 'unset' : `outlined`}
                                    label={`Входящие`} 
                                    onClick={() => setType('Inbounds')}
                                    style={{fontSize: '0.6rem', marginRight: 4, cursor: 'pointer'}}
                                    // icon={<CoffeeIcon style={{marginRight: 2, fontSize: '0.9rem'}}/>}
                                />
                                <Chip 
                                    size="small" 
                                    color="warning" 
                                    variant={type==='Outbounds' ? 'unset' : `outlined`}
                                    onClick={() => setType('Outbounds')}
                                    label={`Исходящие`} 
                                    style={{fontSize: '0.6rem', marginRight: 4, cursor: 'pointer'}}
                                    // icon={<CoffeeIcon style={{marginRight: 2, fontSize: '0.9rem'}}/>}
                                />
                            </span>
                            {type==='Inbounds'&&
                                <span>
                                    <Chip 
                                        size="small" 
                                        color="success" 
                                        variant="outlined" 
                                        label={`Принято: ${inboundTime.value}`} 
                                        style={{fontSize: '0.6rem', marginRight: 4}}
                                        // icon={<CoffeeIcon style={{marginRight: 2, fontSize: '0.9rem'}}/>}
                                    />
                                    <Chip 
                                        size="small" 
                                        color="error" 
                                        variant="outlined" 
                                        label={`Потреяно: ${inboundTime.secondValue}`} 
                                        style={{fontSize: '0.6rem', marginRight: 4}}
                                        // icon={<CoffeeIcon style={{marginRight: 2, fontSize: '0.9rem'}}/>}
                                    />
                                    <Chip 
                                        size="small" 
                                        color="info" 
                                        variant="outlined" 
                                        label={`Время:  ${inboundTime.chip}`} 
                                        style={{fontSize: '0.6rem', marginRight: 4}}
                                        // icon={<CoffeeIcon style={{marginRight: 2, fontSize: '0.9rem'}}/>}
                                    />
                                </span>
                            }
                            {type==='Outbounds'&&
                                <span>
                                    <Chip 
                                        size="small" 
                                        color="success" 
                                        variant="outlined" 
                                        label={`Всего: ${outboundTime.value}`} 
                                        style={{fontSize: '0.6rem', marginRight: 4}}
                                        // icon={<CoffeeIcon style={{marginRight: 2, fontSize: '0.9rem'}}/>}
                                    />
                                    <Chip 
                                        size="small" 
                                        color="error" 
                                        variant="outlined" 
                                        label={`Отвечено: ${outboundTime.secondValue}`} 
                                        style={{fontSize: '0.6rem', marginRight: 4}}
                                        // icon={<CoffeeIcon style={{marginRight: 2, fontSize: '0.9rem'}}/>}
                                    />
                                    <Chip 
                                        size="small" 
                                        color="info" 
                                        variant="outlined" 
                                        label={`Время:  ${outboundTime.chip}`} 
                                        style={{fontSize: '0.6rem', marginRight: 4}}
                                        // icon={<CoffeeIcon style={{marginRight: 2, fontSize: '0.9rem'}}/>}
                                    />
                                </span>
                            }
                        </div>
                    </Typography>
                    {type==='Inbounds'&&
                        <Inbounds inbounds={queues.inbounds}/>
                    }
                    {type==='Outbounds'&&
                        <Outbounds outbounds={queues.outbounds}/>
                    }
                </CardContent>
            </Card>
        </Fragment>
    )
}

export default Queues;